import Modal from "/WebInterface/new-ui/modules/modal.js";
import {
  generateCustomForm,
  attachCustomFormTools,
} from "/WebInterface/new-ui/modules/custom-form/custom-form.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { getCustomForm } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

const extractEventParams = (eventInfo) => {
  const match = eventInfo.match(/customEvent\((\{.*\})\);/);
  if (!match) return {};

  const objectString = match[1].replace(/'/g, '"').replace(/(\w+):/g, '"$1":');
  return JSON.parse(objectString);
};

const sendCustomEvent = async (params, paths, formData = {}) => {
  const obj = {
    command: "customEvent",
    random: Math.random(),
    c2f: utils.cookie.get("currentAuth"),
    ...params,
    ...formData,
    paths: paths,
  };

  const resp = await ajax.call({ data: obj, async: true });
  const xml = new DOMParser().parseFromString(resp, "text/xml");
  const result = utils.xmlToJson(xml);

  if (result?.commandResult?.response?.toLowerCase() === "success") {
    growl(t("customEventInitiated"), t("success"), 5000);
    return true;
  }

  growl(
    t("thereWasSomeProblemWhileRunningCustomEvent"),
    t("failure"),
    5000,
    true
  );
  return false;
};

const showCustomForm = (customForm, eventInfo, paths) => {
  const formName = customForm.name;

  const handleSubmit = async (dialog) => {
    const validateFields = validate(dialog.root, false);

    if (validateFields.length === 0) {
      const messageFormLoader = new Loader({});
      const formData = utils.serializeInputs(dialog.root, false, false);
      const params = extractEventParams(eventInfo);

      try {
        await sendCustomEvent(params, paths, formData);
      } finally {
        messageFormLoader.deleteLoader();
        dialog.hide(true);
      }
    }
  };

  const formContent = generateCustomForm(customForm);

  const customFormDialog = new Modal({
    title: t("customEvent"),
    body: formContent,
    uniqueId: "custom-event-form-modal",
    minWidth: "800px",
    minHeight: "575px",
    buttons: [
      {
        label: "submit",
        close: false,
        classes: ["mr-3"],
        onClick: () => {
          handleSubmit(customFormDialog);
        },
      },
    ],
  });

  attachCustomFormTools(customFormDialog.root, formName);
};

export const initCustomEventForm = (eventInfo, paths) => {
  getCustomForm("customForm", true).then(async (res) => {
    if (res) {
      showCustomForm(res, eventInfo, paths);
    } else {
      const customEventLoader = new Loader({});
      const params = extractEventParams(eventInfo);
      await sendCustomEvent(params, paths);
      customEventLoader.deleteLoader();
    }
  });
};
